// extracted by mini-css-extract-plugin
export var planCard = "_sr-0";
export var planList = "_sr-1";